import React from 'react';

import TableColumnTitle from '../../../../components/_table/TableColumnTitle';
import { CATEGORY_EXHIBIT_TYPE } from '../../../../constants/service/app/categoryConstants';

export const columns = () => [
  {
    title: <TableColumnTitle title="카테고리 명" />,
    dataIndex: 'name',
    render: (value, record) => (
      <span
        className={record.isExhibit === CATEGORY_EXHIBIT_TYPE.EXHIBIT ? 'exhibit-category' : ''}
      >{`${value}(${record.productCount})`}</span>
    ),
  },
];
